type ToggleIndexAction = {
  type: "toggle_index";
  payload: number;
};
type ResetStateAction = {
  type: "reset-state";
};
export type VariantListAccordionActions = ToggleIndexAction | ResetStateAction;

export type VariantListAccordionState = {
  openIndexes: number[];
};

export const initialVariantListAccordionState: VariantListAccordionState = {
  openIndexes: [0],
};

export const variantListAccordionReducer = (
  state: VariantListAccordionState = initialVariantListAccordionState,
  action: VariantListAccordionActions
) => {
  if (action.type === "toggle_index") {
    const closing = state.openIndexes.includes(action.payload);
    return closing
      ? {openIndexes: state.openIndexes.filter((i) => i !== action.payload)}
      : {...state, openIndexes: [...state.openIndexes, action.payload]};
  }
  if (action.type === "reset-state") {
    return initialVariantListAccordionState;
  }
  return state;
};
